import { render, staticRenderFns } from "./TestimonialCycler.vue?vue&type=template&id=2505d920&scoped=true&"
import script from "./TestimonialCycler.vue?vue&type=script&lang=js&"
export * from "./TestimonialCycler.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialCycler.vue?vue&type=style&index=0&id=2505d920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505d920",
  null
  
)

export default component.exports